// extracted by mini-css-extract-plugin
export default {"bookYourStayBox":"BookYourStay_bookYourStayBox__J3ahK","bookYourStay":"BookYourStay_bookYourStay__3bqj+","bookYourStayVisible":"BookYourStay_bookYourStayVisible__Y0x3N"};